import { Directive, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProposalService } from 'src/app/_services/proposal.service';
import { BusinessAccidentMetadata } from 'src/app/_types/lead.types';
import { getBusinessAccidentInsuranceCoverageLabel } from 'src/app/enums/business/business-accident-insurance-coverage.enum';
import { getBusinessWaitingDaysLabel } from 'src/app/enums/business/business-waiting-days.enum';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessAccidentMetadataComponentAbstract extends BaseMetadataComponent<BusinessAccidentMetadata> {
  getBooleanLabel = getBooleanLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getBusinessWaitingDaysLabel = getBusinessWaitingDaysLabel;

  getBusinessAccidentInsuranceCoverageLabel =
    getBusinessAccidentInsuranceCoverageLabel;

  constructor(
    proposalService: ProposalService,
    private readonly router: Router
  ) {
    super(proposalService);
  }

  @Input()
  userId: string;

  viewCollaborator(collaboratorId: string): void {
    if (this.userId) {
      this.router.navigate([
        '/customers/view/collaborator',
        this.userId,
        collaboratorId,
      ]);
    }
  }

  // Helper methods to check if objects are empty
  isCoveragesEmpty(coverages: any): boolean {
    if (!coverages) return true;
    return Object.values(coverages).every(
      (value) =>
        value === null ||
        value === undefined ||
        value === false ||
        (Array.isArray(value) && value.length === 0) ||
        value === ''
    );
  }

  isAdditionalCoveragesEmpty(additionalCoverages: any): boolean {
    if (!additionalCoverages) return true;
    return Object.values(additionalCoverages).every(
      (value) =>
        value === null || value === undefined || value === false || value === ''
    );
  }

  isContractInfoEmpty(metadata?: BusinessAccidentMetadata): boolean {
    if (!metadata) return true;
    return (
      !metadata.startDate &&
      !metadata.contractDuration &&
      !metadata.paymentFrequency &&
      (metadata.splitPaymentFee === null ||
        metadata.splitPaymentFee === undefined)
    );
  }

  isInsuredPersonsEmpty(insuredPersons: any[] | undefined): boolean {
    return !insuredPersons || insuredPersons.length === 0;
  }

  isLaaInfoEmpty(metadata?: BusinessAccidentMetadata): boolean {
    if (!metadata) return true;
    return (
      metadata.professionalMenTotalSalary === undefined &&
      metadata.professionalWomenTotalSalary === undefined &&
      metadata.nonProfessionalMenTotalSalary === undefined &&
      metadata.nonProfessionalWomenTotalSalary === undefined &&
      metadata.womenCount === undefined &&
      metadata.menCount === undefined &&
      (metadata.hasCollectiveContract === null ||
        metadata.hasCollectiveContract === undefined) &&
      !metadata.collectiveContract &&
      (metadata.suvaOnly === null || metadata.suvaOnly === undefined) &&
      (metadata.baseInsurance === null ||
        metadata.baseInsurance === undefined) &&
      (metadata.complementaryInsurance === null ||
        metadata.complementaryInsurance === undefined)
    );
  }

  isCurrentInsuranceEmpty(metadata?: BusinessAccidentMetadata): boolean {
    if (!metadata) return true;
    return (
      (metadata.hasInsurance === null || metadata.hasInsurance === undefined) &&
      !metadata.currentInsurer &&
      (metadata.hasClaimsLastFiveYears === null ||
        metadata.hasClaimsLastFiveYears === undefined) &&
      (metadata.hasclaimsLastFiveYears === null ||
        metadata.hasclaimsLastFiveYears === undefined)
    );
  }
}
